import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React from "react";
import SectionsHeading from "../../MainComponent/SectionsHeading";
import image from "../../../../assets/Images/heroImage.png"
import { AbsoluiteImage, CardGrid } from "../../../Styles/style";
import MarketeTable from "./MarketTable";

const GridWrapper = styled(Grid)`
  display: flex;
  width: 100%;
  height: auto;
  column-gap: 20px;
  row-gap: 20px;
`;


const CoulmnDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`;

const MarketHome = () => {
  return (
    <GridWrapper container>
      <CardGrid item xs={12} sx={{position:"relative"}}>
        <CoulmnDiv>
          <SectionsHeading fm="PoppinsSB" fs="22px" fs599="16px" ta="left" color="#FC9D00">
          Total Market Size
          </SectionsHeading>
          <SectionsHeading p="10px 0" p899="10px 0" p599="10px 0" fm="PoppinsR" fs="32px"  fs599="22px" ta="left" >
          $500,000
          </SectionsHeading>
        </CoulmnDiv>
        <AbsoluiteImage mw="200px" mw599="140px" t="0%" l="85%" l899="70%" t899="10%" src={image}/>
      </CardGrid>
      <CardGrid item xs={12}>
        <MarketeTable src={image}/>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
    </GridWrapper>
  );
};

export default MarketHome;
